import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import './Header.css';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  
  // Check if we're on the homepage
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Prevent body scroll when menu is open on mobile
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape' && isMenuOpen) {
      setIsMenuOpen(false);
    }
  };

  return (
    <header className={`header ${isScrolled || !isHomePage ? 'scrolled' : ''}`} onKeyDown={handleKeyDown}>
      <div className="container">
        <Link to="/" className="logo" onClick={handleLinkClick} aria-label="Notary Public Express Service - Home">
            <div className="logo-text">
              <span className="logo-main">Notary Public Express Service</span>
              <span className="logo-sub">Professional • Reliable • Convenient</span>
            </div>
        </Link>
        
        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`} aria-label="Main navigation">
          <ul className="nav-links">
            <li><Link to="/" onClick={handleLinkClick} className="nav-link">Home</Link></li>
            <li>
              <HashLink to="/#services" onClick={handleLinkClick} className="nav-link">Services</HashLink>
            </li>
            <li>
              <HashLink to="/#about" onClick={handleLinkClick} className="nav-link">About</HashLink>
            </li>
            <li>
              <HashLink to="/#testimonials" onClick={handleLinkClick} className="nav-link">Reviews</HashLink>
            </li>
            <li>
              <HashLink to="/#contact" onClick={handleLinkClick} className="nav-link">Contact</HashLink>
            </li>
          </ul>
        </nav>
        
        <button 
          className={`menu-toggle ${isMenuOpen ? 'menu-open' : ''}`}
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isMenuOpen}
          aria-controls="main-navigation"
          onClick={toggleMenu}
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
      </div>
      
      {/* Mobile menu overlay */}
      {isMenuOpen && <div className="menu-overlay" onClick={() => setIsMenuOpen(false)} />}
    </header>
  );
};

export default Header;